import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export interface ChecklistStatusResponse {
  plan_generated: boolean;
  resume_upload: boolean;
  career_goal: string | null;
  job_shared: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ChecklistService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  getChecklistStatus(): Observable<ChecklistStatusResponse> {
    return this.get<ChecklistStatusResponse>('checklist');
  }
}

